import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardHeader,
    Text,
    makeStyles,
    tokens,
} from "@fluentui/react-components";
import { TableSearchRegular } from "@fluentui/react-icons";

interface ModuleCard {
    title: string;
    caption: string;
    description: string;
    icon: React.ReactElement;
    route: string;
}

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    },
    image: {
        fontSize: "32px",
        color: tokens.colorBrandForeground1,
    },
    card: {
        cursor: "pointer",
    },
    caption: {
        color: tokens.colorNeutralForeground3,
    },
    description: { margin: "0" },
});

const HomePage: React.FC = () => {
    const styles = useStyles();
    const navigate = useNavigate();

    const modules: ModuleCard[] = [
    {
        title: "Article Enrichment",
        caption: "Module",
        description: "Look up and enrich article data from your catalog.",
        icon: <TableSearchRegular className={styles.image} />,
        route: "/article-enrichment",
    },
];

    return (
        <div className={styles.root}>
            {modules.map((mod) => (
                <Card
                    key={mod.route}
                    className={styles.card}
                    onClick={() => navigate(mod.route)}
                    appearance="filled"
                >
                    <CardHeader
                        image={mod.icon}
                        header={
                            <Text as="h5" weight="semibold" style={{ margin: 0 }}>
                                {mod.title}
                            </Text>
                        }
                    />

                    <p className={styles.description}>
                        {mod.description}
                    </p>
                </Card>
            ))}
        </div>
    );
};

export default HomePage;
